export default __webpack_public_path__ + "static/media/bomba_2.3c961494.gif";